export default __webpack_public_path__ + "static/media/ReactNative.750b4409.png";